import { getNewsPageBlock } from './getNewsPageBlock'
import { getNews } from './getNews'
import { getNewsDetails } from './getNewsDetails'
import { getNewsPageBlockSeo } from './getNewsPageBlockSeo'
import { getNewsDetailsSeo } from './getNewsDetailsSeo'

export * from './getNewsPageBlock'
export * from './getNews'
export * from './getNewsDetails'
export * from './getNewsPageBlockSeo'
export * from './getNewsDetailsSeo'

export const newsApi = {
  getNewsPageBlock,
  getNews,
  getNewsDetails,
  getNewsPageBlockSeo,
  getNewsDetailsSeo,
}
